import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { skeletonLoading } from './utils'

import Icon from '@/checkout-instore-legacy/components/Commons/Icons'

interface DeliveryStockLabelProps {
  hasDelivery: boolean
  loading: boolean
}

const loadDeliveryStock = (hasDelivery: boolean) => {
  return {
    color: hasDelivery ? 'c-on-base' : 'c-muted-2 strike',
    testid: hasDelivery
      ? 'available-delivery-stock-label'
      : 'unavailable-delivery-stock-label',
    id: hasDelivery
      ? 'product.stock.delivery.available'
      : 'product.stock.delivery.unavailable',
  }
}
const ICON_SIZE = 20

const DeliveryStockLabel: FC<DeliveryStockLabelProps> = ({
  hasDelivery,
  loading,
}) => {
  const { color, testid, id } = loadDeliveryStock(hasDelivery)

  if (loading) {
    return skeletonLoading
  }

  return (
    <span className={`lh-copy truncate ${color}`} data-testid={testid}>
      <span className="mr2 di ph1">
        <Icon type="nc-delivery" color="currentColor" size={ICON_SIZE} />
      </span>
      <span className="t-small" data-testid="stockDeliveryInfo">
        <FormattedMessage id={id} />
      </span>
    </span>
  )
}

export default DeliveryStockLabel
